export const player = { x: 0, z: 7, yaw: 0, pitch: -0.05 };
export const input = { keys: new Set(), joy: { x: 0, y: 0 } };

export const BOUNDS = { minX: -15.2, maxX: 15.2, minZ: -21.2, maxZ: 7.4 };
export const RECEPTION = { x: 0, z: -2.6, r: 3.2 };
export const OBSTACLES = [
  { minX: -12.9, maxX: -7.1, minZ: 2.0, maxZ: 5.3 },
  { minX: 15.0, maxX: 15.9, minZ: 3.2, maxZ: 4.0 },
  { minX: -3.9, maxX: 3.9, minZ: -5.9, maxZ: -4.3 },
  { minX: 14.7, maxX: 15.9, minZ: 5.1, maxZ: 6.1 },
  { minX: 14.7, maxX: 15.9, minZ: -1.7, maxZ: -0.7 },
  { minX: -15.9, maxX: -14.7, minZ: -1.7, maxZ: -0.7 },
  { minX: -12.5, maxX: -11.5, minZ: -21.9, maxZ: -20.8 },
  { minX: 11.5, maxX: 12.5, minZ: -21.9, maxZ: -20.8 },
];
const PAD = 0.45;

export function approachPoint(dep) {
  const nx = Math.sin(dep.rotation || 0);
  const nz = Math.cos(dep.rotation || 0);
  return { x: dep.x + nx * 2.6, z: dep.z + nz * 2.6 };
}

function blocked(x, z) {
  if (Math.hypot(x - RECEPTION.x, z - RECEPTION.z) < RECEPTION.r + 0.3) return true;
  return OBSTACLES.some((o) => x > o.minX - PAD && x < o.maxX + PAD && z > o.minZ - PAD && z < o.maxZ + PAD);
}

function clear(a, b) {
  const n = Math.ceil(Math.hypot(b.x - a.x, b.z - a.z) / 0.2);
  for (let i = 1; i < n; i++) if (blocked(a.x + ((b.x - a.x) * i) / n, a.z + ((b.z - a.z) * i) / n)) return false;
  return true;
}

const inside = (p) => p.x >= BOUNDS.minX && p.x <= BOUNDS.maxX && p.z >= BOUNDS.minZ && p.z <= BOUNDS.maxZ;
const NODES = [
  ...Array.from({ length: 12 }, (_, i) => ({ x: RECEPTION.x + Math.sin((i * Math.PI) / 6) * (RECEPTION.r + 1.1), z: RECEPTION.z + Math.cos((i * Math.PI) / 6) * (RECEPTION.r + 1.1) })),
  ...OBSTACLES.flatMap((o) => [[o.minX, o.minZ], [o.minX, o.maxZ], [o.maxX, o.minZ], [o.maxX, o.maxZ]]
    .map(([x, z]) => ({ x: x + (x === o.minX ? -0.9 : 0.9), z: z + (z === o.minZ ? -0.9 : 0.9) }))),
].filter((p) => inside(p) && !blocked(p.x, p.z));

const plen = (pts) => pts.reduce((s, p, i) => (i ? s + Math.hypot(p.x - pts[i - 1].x, p.z - pts[i - 1].z) : 0), 0);

export function buildPath(from, to) {
  if (clear(from, to)) return [to];
  let best = null;
  const consider = (pts) => { if (!best || plen(pts) < plen(best)) best = pts; };
  for (const a of NODES) {
    if (!clear(from, a)) continue;
    if (clear(a, to)) consider([from, a, to]);
    for (const b of NODES) if (b !== a && clear(a, b) && clear(b, to)) consider([from, a, b, to]);
  }
  if (best) return best.slice(1);
  const side = from.x >= 0 ? 1 : -1;
  return [{ x: side * (RECEPTION.r + 2.2), z: RECEPTION.z }, to];
}

export function clampPos(x, z) {
  let nx = Math.min(BOUNDS.maxX, Math.max(BOUNDS.minX, x));
  let nz = Math.min(BOUNDS.maxZ, Math.max(BOUNDS.minZ, z));
  const dx = nx - RECEPTION.x;
  const dz = nz - RECEPTION.z;
  const d = Math.hypot(dx, dz);
  if (d < RECEPTION.r) {
    nx = RECEPTION.x + (dx / (d || 1)) * RECEPTION.r;
    nz = RECEPTION.z + (dz / (d || 1)) * RECEPTION.r;
  }
  for (const o of OBSTACLES) {
    if (nx > o.minX && nx < o.maxX && nz > o.minZ && nz < o.maxZ) {
      const push = [[o.minX - nx, 0], [o.maxX - nx, 0], [0, o.minZ - nz], [0, o.maxZ - nz]]
        .sort((a, b) => Math.abs(a[0] + a[1]) - Math.abs(b[0] + b[1]))[0];
      nx += push[0];
      nz += push[1];
    }
  }
  const rx = nx - RECEPTION.x;
  const rz = nz - RECEPTION.z;
  const rd = Math.hypot(rx, rz);
  if (rd < RECEPTION.r) {
    nx = RECEPTION.x + (rx / (rd || 1)) * RECEPTION.r;
    nz = RECEPTION.z + (rz / (rd || 1)) * RECEPTION.r;
  }
  return [nx, nz];
}
